<template>
  <div>
    <v-btn
      color="primary"
      :disabled="disabled"
      :x-large="xLargeButton"
      :large="largeButton"
      :small="smallButton"
      @click="showEmissionDialogButtonClickEvent"
    >
      {{ buttonCaption }}
    </v-btn>
    <!-- 排出 -->
    <choose-emission-modal
      :enable="enableEmissionDialog"
      :without-general-form="withoutGeneralForm"
      :without-invisible="withoutInvisible"
      :only-valid-location="onlyValidLocation"
      @selected="registerEmissionButtonClickEvent"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import PrefectureList from "@/mixins/PrefectureList";
import ChooseEmissionModal from "./ChooseEmissionModal.vue";

/**
 * 取引先選択ダイアログの呼び出し
 * 選択肢として、排出、または収運・処分を一覧形式で表示し、呼び出し元画面に選択した結果を返します。
 *
 * 呼び出し元は以下のコールバックを定義してください。
 * ・choseEmissionCallback
 *  @return emission [Object] 排出
 *  ・choseTraderCallback
 *  @return trader [Object] 収運・処分業者
 */
export default {
  name: "ChooseEmissionButton",
  components: {
    ChooseEmissionModal,
  },
  mixins: [PrefectureList],
  props: {
    buttonCaption: {
      type: String,
      default: () => "取引先を選択",
    },
    xLargeButton: {
      type: Boolean,
      default: () => false,
    },
    largeButton: {
      type: Boolean,
      default: () => false,
    },
    smallButton: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    exclusionIds: {
      type: Array,
      default: () => [],
    },
    searchType: {
      type: String,
      default: () => null,
    },
    withoutGeneralForm: {
      type: Boolean,
      default: () => false,
    },
    withoutInvisible: {
      type: Boolean,
      default: () => false,
    },
    onlyValidLocation: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      enableEmissionDialog: false,
    };
  },
  computed: {},
  watch: {
  },
  created() {
  },
  methods: {
    /**
     * 排出事業者から選択メニュー クリックイベント
     */
    showEmissionDialogButtonClickEvent() {
      this.enableEmissionDialog = true;
    },
    /**
     * 排出事業者 反映ボタン クリックイベント
     * 呼び出し元で定義されたコールバックをキックし、選択された排出事業者情報を返します.
     */
    registerEmissionButtonClickEvent(item) {
      this.$emit("choseEmissionCallback", item);
      this.closeDialog();
    },
    /**
     * ダイアログを閉じる
     */
    closeDialog() {
      this.enableEmissionDialog = false;
    },
    scrollToTop() {
      const elements = document.getElementsByClassName("v-dialog--active");
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName("card-layer");
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  },
};
</script>
